import React, { useRef } from "react";
import PropTypes from "prop-types";
import { useTrans } from "../../hooks";

import { ConnectImage, Icon, Modal, MODAL_ID } from "../../shared-components";
import { Button, ButtonVariant } from "@wattpad/web-ui-library";

const PremiumPicksFAQModal = ({ showModal, onClose }) => {
  const modalRef = useRef();
  const { trans } = useTrans();

  const handleClose = () => {
    onClose();
    modalRef.current.hide();
  };

  const checkIcon = (
    <div className="check-icon-container">
      <Icon
        name="check"
        size="24"
        viewBox="24"
        color="ds-neutral-100"
        className="check-icon"
        fill={true}
        strokeWidth="0"
      />
    </div>
  );

  return (
    <Modal
      id={MODAL_ID.PREMIUM_PICKS_FAQ_MODAL_ID}
      {...{ showModal, onClose }}
      ref={modalRef}
    >
      <div className="premium-picks-faq-content">
        <div className="premium-picks-faq-header">
          <h2 className="modal-title">{trans("Premium Picks")}</h2>
          <ConnectImage
            className="premium-picks-image"
            name={`library/premium-picks-banner-books.png`}
          />
        </div>

        <ul className="premium-picks-faq-features">
          <li>
            {checkIcon}
            {trans(
              "Get access to 5 curated Wattpad Originals every month—for free!"
            )}
          </li>
          <li>
            {checkIcon}
            {trans("Wattpad Originals refresh on the first day of each month.")}
          </li>
          <li>
            {checkIcon}
            {trans(
              "Indulge in quality reads, no ads, unlimited offline reading, and more, for the same great price."
            )}
          </li>
        </ul>
      </div>
      <div className="premium-picks-faq-footer">
        <Button variant={ButtonVariant.PRIMARY} onClick={handleClose}>
          {trans("Got it")}
        </Button>
        <a
          href="https://support.wattpad.com/hc/en-us/articles/18722782071956-Premium-Picks-"
          className="premium-picks-faq-link"
        >
          {trans("Learn more")}
        </a>
      </div>
    </Modal>
  );
};

PremiumPicksFAQModal.propTypes = {
  showModal: PropTypes.bool,
  onClose: PropTypes.func
};

export default PremiumPicksFAQModal;
